import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-virtual-museum',
  templateUrl: './virtual-museum.component.html',
  styleUrls: ['./virtual-museum.component.scss']
})
export class VirtualMuseumComponent implements OnInit {
  museumLink = environment.link_museum;

  constructor() { }

  ngOnInit() {
    // Redirect to external link
    window.location.href = this.museumLink;
  }
}
